export default __webpack_public_path__ + "static/media/icon_paw.a3b34ad5.svg";